// imports react
import React, { useEffect, useState } from "react";

//imports components
import styles from "../../styles/userManagement.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { urlAPI_Current } from "../../config";
import axios from "axios";
import { Menu } from "../../components/Menu";
import { AdminNotesUser } from "../../components/AdminNotesUser";
import { AdminDimensionalUser } from "../../components/AdminDimensionalUser";
import { AdminSkillsUser } from "../../components/AdminSkillsUser";
import { verifyAuthToken } from "../../verifyAuthToken";

export function UserManagement() {
  const { userId } = useParams();
  const [userData, setUserData] = useState([]);
  const [userNotes, setUserNotes] = useState([]);
  const [activeTab, setActiveTab] = useState('notas');

  const navigateTo = useNavigate();

  const [darkMode, setDarkMode] = useState(
    () => window.localStorage.getItem("darkMode") === "true"
  );

  async function getUserData() {
    try {
      const responseSkills = await axios.post(`${urlAPI_Current}/getProfileByAdmin`, {
        selectedUserId: userId,
      } , {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
     });
      if (responseSkills.data.success == true) {
        const userInfo = responseSkills.data.user;
        setUserData(userInfo);

        console.log("Usuário possui dados");
      } else {
        console.log("Usuário não possui dados");
      }
    } catch (error) {
      console.log("Erro ao buscar dados");
      toast.error("Usuário não encontrado");
      navigateTo("/admin/painel");
    }
  }

  async function getAllNotesUser() {
    try {
      const responseSkills = await axios.post(`${urlAPI_Current}/getAllNotes`, {
        selectedUserId: userId,
      } , {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
     });
      if (responseSkills.data.success == true) {
        const userNotes = responseSkills.data.notes;
        console.log(userNotes);
        setUserNotes(userNotes);

        console.log("Usuário possui notas");
      } else {
        console.log("Usuário não possui notas");
      }
    } catch (error) {
      console.log("Erro ao buscar notas");
    }
  }

  function formatDate(dataString) {
    const date = new Date(dataString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Janeiro é 0!
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  useEffect(() => {
    const fetchData = async () => {
        try {

            const responseEmail = await axios.post(
                `${urlAPI_Current}/getProfile`, {
                } , {
                  headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                  }
               }
            );

            if (responseEmail.data.user.codTipoUsuario == 2) {
              if(userId){
                getUserData();
                getAllNotesUser();
              } else {
                toast.error("Usuário não encontrado");
                navigateTo("/admin/painel");
              }
            } else {
                toast.error("Você não tem acesso a essa página");
                navigateTo("/login");
            }
        } catch (error) {
            console.error("Erro ao buscar perfil:", error);
        }
    };

    fetchData();

    window.localStorage.setItem('darkMode', darkMode);
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  useEffect(() => {
    verifyAuthToken(navigateTo);
  }, []);

  return (
    <div>
      <Menu darkMode={darkMode} adminUser={true} buttonBack={true} />
      <div
        className="d-flex flex-column flex-lg-row"
        style={{
          marginTop: "136px",
          marginLeft: "48px",
          marginRight: "48px",
        }}
        data-bs-theme={darkMode ? "dark" : "light"}
      >
        <div className="flex-column flex-lg-row-auto w-lg-250px w-xl-350px mb-10">
          <div className="card mb-5 mb-xl-8" style={{ height: '100%' }}>
            <div className="card-body">
              <div className="d-flex flex-center flex-column py-5">
                <div className="symbol symbol-100px symbol-circle mb-7">
                  {userData.foto ? (
                    <img
                      src={`https://evoktm.com.br/evokchat/fotos_usuarios/${userData.foto}`}
                      alt="Foto do usuário"
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <div
                      className="symbol-label fs-3 bg-primary text-white"
                      style={{ cursor: "pointer" }}
                    >
                      {userData.nome
                        ? userData.nome.slice(0, 2).toUpperCase()
                        : "N/A"}
                    </div>
                  )}
                </div>
                <p
                  className="fs-3 text-gray-800 text-hover-primary fw-bold mb-3"
                >
                  {userData.nome}
                </p>

                <div className="mb-9">
                  <div className="badge badge-lg badge-light-primary d-inline">
                    Cliente
                  </div>
                </div>
              </div>

              <div className="d-flex flex-stack fs-4 py-3">
                <div
                  className="fw-bold rotate collapsible"
                  data-bs-toggle="collapse"
                  role="button"
                >
                  Detalhes
                  <span className="ms-2 rotate-180">
                    <i className="ki-outline ki-down fs-3"></i>
                  </span>
                </div>
              </div>

              <div className="separator"></div>

              <div id="kt_user_view_details" className="collapse show">
                <div className="pb-5 fs-6">
                  <div className="fw-bold mt-5">Codigo Usuario</div>
                  <div className="text-gray-600">{userData.codUsuario}</div>

                  <div className="fw-bold mt-5">Email</div>
                  <div className="text-gray-600">
                    <p className="text-gray-600 text-hover-primary">
                      {userData.email}
                    </p>
                  </div>

                  <div className="fw-bold mt-5">Celular</div>
                  <div className="text-gray-600">{userData.celular}</div>

                  <div className="fw-bold mt-5">Data Nascimento</div>
                  <div className="text-gray-600">
                    {formatDate(userData.data_nasc)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-lg-row-fluid ms-lg-15">
          <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-8">
            <li className="nav-item">
              <p
               className={`nav-link text-active-primary ${activeTab === 'notas' ? 'active' : ''}`}
                onClick={() => setActiveTab('notas')}
                style={{cursor: "pointer"}}
              >
                Notas Questionario
              </p>
            </li>

            <li className="nav-item">
              <p
               className={`nav-link text-active-primary ${activeTab === 'perfilDimensional' ? 'active' : ''}`}
                onClick={() => setActiveTab('perfilDimensional')}
                style={{cursor: "pointer"}}
              >
                Perfil Dimensional
              </p>
            </li>

            <li className="nav-item">
              <p
               className={`nav-link text-active-primary ${activeTab === 'habilidades' ? 'active' : ''}`}
                onClick={() => setActiveTab('habilidades')}
                style={{cursor: "pointer"}}
              >
                Habilidades
              </p>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="kt_user_view_overview_tab"
              role="tabpanel"
            >
              {activeTab === 'notas' ? (
                <AdminNotesUser userData={userData} darkMode={darkMode} userNotes={userNotes}/>
              ) : activeTab === 'perfilDimensional' ? (
                <AdminDimensionalUser userData={userData} darkMode={darkMode}/>
              ) : activeTab === 'habilidades' ? (
                <AdminSkillsUser userData={userData} darkMode={darkMode} />
              )  : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
